import { render, staticRenderFns } from "./EditPhotos.vue?vue&type=template&id=652e0152&"
import script from "./EditPhotos.vue?vue&type=script&lang=js&"
export * from "./EditPhotos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports